export const Loupe = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.056 9.52802C19.056 14.7902 14.7902 19.056 9.52802 19.056C4.26584 19.056 0 14.7902 0 9.52802C0 4.26584 4.26584 0 9.52802 0C14.7902 0 19.056 4.26584 19.056 9.52802ZM2.27554 9.52802C2.27554 13.5335 5.52259 16.7805 9.52802 16.7805C13.5335 16.7805 16.7805 13.5335 16.7805 9.52802C16.7805 5.52259 13.5335 2.27554 9.52802 2.27554C5.52259 2.27554 2.27554 5.52259 2.27554 9.52802Z'
        fill='#B1B1B1'
      />
      <rect
        x='14.0391'
        y='15.6797'
        width='2.37529'
        height='7.87815'
        transform='rotate(-45 14.0391 15.6797)'
        fill='#B1B1B1'
      />
    </svg>
  );
};
